import React, { useState } from 'react';
import ChatBubble from "./ChatBubble";
import ShadowWrapper from './ShadowWrapper';
import ErrorBoundary from './ErrorBoundary';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const [cssReady, setCssReady] = useState(false); // Track CSS readiness

  return (
    <div className="App">
      <ErrorBoundary> 
        <ShadowWrapper onCssReady={() => setCssReady(true)}>
          {cssReady && <ChatBubble />} {/* Render ChatBubble only when CSS is ready */}
        </ShadowWrapper>
      </ErrorBoundary> 

      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default App;
